import React from 'react';
import styled from "styled-components";
import {NavLink} from "react-router-dom";


const Navbar = () => {
  return (
    <Wrapper>
    <div className="menu">
            <div className="container">
                <div className="row flex">
                    <div className="logo">
                        <NavLink to="/">
                            <img src="./images/logo.png" alt="logo" />
                        </NavLink>
                    </div>
                    <div className="menu-bar ">
                        <ul>
                            <li><NavLink to="/">Home</NavLink></li>
                            <li><NavLink to="/about">About</NavLink></li>
                            <li><NavLink to="/contact">Contact</NavLink></li>
                            <li><NavLink to="/service">Services</NavLink></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        </Wrapper>
    
  )
};
const Wrapper = styled.section`
* {
    padding: 0;
    margin: 0;
    color: white;
    }

li {
    list-style: none;
}

.container {
    width: 100%;
    margin: auto;
    padding-right: 15px;
    padding-left: 15px;
    justify-content: space-between;
}

.row {
    padding: 1rem;
}

.menu {
    width: 100%;
}

.logo {
    width: 10%;
}

.logo img {
    height: 6rem;
}

.menu-bar {
    width: 90%;
    margin: auto auto;
}

.menu-bar ul {
    list-style: none;
    display: flex;
    justify-content: end;
}

.menu-bar ul li {
    padding: 0 2rem;
}

.menu-bar ul li a {
    color: black;
    text-decoration: none;
    font-size: 2rem;
    font-weight: bold;
    text-transform: uppercase;
    border-bottom: 0.3rem solid #58c4a7;
    border-radius: 6px;
}
.flex {
    display: flex;
  }
  .ai-center {
    align-items: center;
  }
  @media (max-width:998px) {
    .menu-bar ul li a {
        font-size: 3rem;
    }
  }
  
  @media (max-width:768px) {
    .menu-bar ul li a {
        font-size: 2.5rem;
    }
  }
  @media (max-width:599px) {
   
  }
  @media (max-width:450px) {
    .menu-bar ul {
        list-style: none;
        display: grid;
        grid-template-columns: auto auto ;
        justify-content: end;
    }
  }
`;

export default Navbar;